import { OrderDetailsCancelFormValues } from "../types/OrderDetailsCancelFormValues";

export const EMPTY_CANCEL_ORDER_FORM: OrderDetailsCancelFormValues = {
  cancelledReason: "",
  orderId: "",
};
